import React, {useEffect, useState} from "react";
import {useStores} from "../hooks/useStores";
import {observer} from "mobx-react-lite";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCheck} from '@fortawesome/free-solid-svg-icons';
import "./Presets.css";

export const Presets = observer(() => {

    const {presetsStore: store} = useStores();

    //const [name, setName] = React.useState(store.selectedName);

    const [saved, setSaved] = useState(false);

    const [showConfirmation, setShowConfirmation] = useState(false);

    const loadPreset = (e: React.ChangeEvent<HTMLSelectElement>) => {
        // console.log('loadPreset', e.currentTarget.value);
        store.loadPreset(parseInt(e.currentTarget.value, 10));
    }

    const updateName = (e: React.FormEvent<HTMLInputElement>) => {
        //setName(e.currentTarget.value);
        store.updateSelectedName(e.currentTarget.value);
    }

    const savePreset = () => {
        // store.addPreset(store.selectedName);
        store.savePreset();
        setSaved(true);
    }

    useEffect(() => {
        if (saved) {
            // console.log("presets useeffect", saved);
            setSaved(false);
            setShowConfirmation(true);
            setTimeout(() => setShowConfirmation(false), 2000);
        }
    }, [saved])

    //if (store.selected >= 0) setName(store.presets[store.selected].name);

    return (
        <div className="presets">
            {/*<div className="preset-name">*/}
                <input type="text" value={store.selectedName} onChange={updateName} />
            {/*</div>*/}
            <div>
                <div>
                    <select onChange={loadPreset} value="-1">
                        <option value="-1">load preset</option>
                        {store.presets.map(
                            (preset, index) => <option key={index} value={index}>{preset.name}</option>
                        )}
                    </select>
                </div>
                <div>
                    {showConfirmation && <div className="confirmation">done <FontAwesomeIcon icon={faCheck} /></div>}
                    {!showConfirmation && <button onClick={savePreset}>{(store.selectedName && store.selected > -1) ? 'update preset' : 'save preset'}</button>}
                </div>
            </div>
        </div>
    );

});
